export const TITLE = "title";
export const DESCRIPTION = "description";
export const CHECKLIST_ITEM = "checklistItems";
export const NAME = 'name';
export const IMPORTANCE_FLAG = "importanceFlag";